import { Price, Currency } from '@pancakeswap/sdk'
import { Flex, Text } from '@pancakeswap/uikit'
import { multiplyPriceByAmount } from 'utils/prices'
import { useTranslation } from '@pancakeswap/localization'
import { useConfig } from 'views/Predictions/context/ConfigProvider'
import { formatBnb, formatUsdPro } from '../helpers'

type SummaryType = 'won' | 'lost' | 'entered'

interface SummaryRowProps {
  type: SummaryType
  summary: any
  bnbBusdPrice: number
}

const summaryTypeColors = {
  won: 'success',
  lost: 'failure',
  entered: 'text',
}

const summaryTypeSigns = {
  won: '',
  lost: '-',
  entered: '',
}

const SummaryRow: React.FC<React.PropsWithChildren<SummaryRowProps>> = ({ type, summary, bnbBusdPrice }) => {
  const { t } = useTranslation()

  const color = summaryTypeColors[type]
  const { rounds, amount } = summary[type]
  const totalRounds = summary.entered.rounds
  const roundsInPercents = ((rounds * 100) / totalRounds).toFixed(2)
  const typeTranslationKey = type.charAt(0).toUpperCase() + type.slice(1)
  const displayAmount = type === 'won' ? summary[type].payout : amount
  const amountInUsd = bnbBusdPrice * Number(displayAmount)
  const { token, displayedDecimals } = useConfig()
  const roundsInPercentsDisplay = !Number.isNaN(parseFloat(roundsInPercents)) ? `${roundsInPercents}%` : '0%'

  return (
    <>
      <Text mt="16px" mb="4px" fontSize="14px">
        {t(typeTranslationKey)}
      </Text>
      <Flex>
        <Flex flex="2" flexDirection="column">
          <Text fontWeight={700} fontSize="14px" color={color}>
            {rounds} {rounds > 1 ? 'rounds' : 'round'}
          </Text>
          <Text fontSize="12px" textTransform="capitalize" color="white60">
            {type === 'entered' ? t('Total').toLocaleLowerCase() : roundsInPercentsDisplay}
          </Text>
        </Flex>
        <Flex flex="3" flexDirection="column">
          <Text fontWeight={700} fontSize="14px" color={color}>
            {`${summaryTypeSigns[type]}${formatBnb(displayAmount, 2)} FTM`}
          </Text>
          <Text fontSize="12px" textTransform="capitalize" color="white60">
            {formatUsdPro(amountInUsd, 2)}
            {/* {`~ ${summaryTypeSigns[type]}${formatUsdPro(amountInUsd, 2)}`} */}
          </Text>
        </Flex>
      </Flex>
    </>
  )
}

export default SummaryRow
